import React from 'react'
import { IoLogoYoutube } from "react-icons/io5";
import { FaSquareXTwitter } from "react-icons/fa6";


function MainFooter() {
	return (
		<>
			{/* Footer Start  */}
			<div className="container-fluid footer py-5 wow fadeIn" data-wow-delay="0.2s">
				<div className="container">
					<div className="row">
						<div className="col-md-6 col-lg-6 col-xl-3 mt-2">
							<div className="footer-item d-flex flex-column">
								<div>
									<p to="#0" className="logo d-flex align-items-center">
										<span style={{ paddingLeft: "0px" }}>Fever99</span>
									</p>
								</div>
								<p className='text-white'>We are here to serve you and address your healthcare needs. Contact Fever99 today to schedule an appointment or to learn more about our services.</p>
							</div>
						</div>
						<div className="col-md-6 col-lg-6 col-xl-3 mt-2">
							<div className="footer-item d-flex flex-column">
								<h4 className="mb-2">Quick ps</h4>
								<p to="#"><i className="fas fa-angle-right me-2"></i>Home</p>
								<p to="/career"><i className="fas fa-angle-right me-2"></i>Career</p>
								<p to="/refuncpolicy"><i className="fas fa-angle-right me-2"></i>Cancellation & Refund Policy</p>
								<p to="/terms-condition"><i className="fas fa-angle-right me-2"></i>Terms of service</p>
								<p to="/privacy"><i className="fas fa-angle-right me-2"></i>Privacy policy</p>
								<p to="/register"><i className="fas fa-angle-right me-2"></i>Join Us</p>
								<p to="/faq"><i className="fas fa-angle-right me-2"></i>Frequently</p>
								<p to="/gallery"><i className="fas fa-angle-right me-2"></i>Gallery</p>
							</div>
						</div>
						<div className="col-md-6 col-lg-6 col-xl-3 mt-2">
							<div className="footer-item d-flex flex-column">
								<h4 className="mb-2">Our Services</h4>
								<p to="/home-service/physiotherapy-at-home"><i className="fas fa-angle-right me-2"></i>Physiotherapy</p>
								<p to="/home-service/doctor-video-consultation"><i className="fas fa-angle-right me-2"></i>Video Consulttion</p>
								<p to="/home-service/24x7-ambulance-on-call"><i className="fas fa-angle-right me-2"></i>Ambulance on call</p>
								<p to="/home-service/vaccination-at-home"><i className="fas fa-angle-right me-2"></i>Vaccinations at home</p>
								<p to="/home-service/ecg-and-x-ray-at-home"><i className="fas fa-angle-right me-2"></i>ECG and X-Ray at home</p>
								<p to="/home-service/healthcare-product-at-home"><i className="fas fa-angle-right me-2"></i>Healthcare Product at Home</p>
							</div>
						</div>
						<div className="col-md-6 col-lg-6 col-xl-3 mt-2">
							<div className="footer-item d-flex flex-column">
								<h4 className="mb-2">Contact with us</h4>
								<p to=""><i className="fa fa-map-marker-alt px-1"></i>Shop No 97, Conscient Habitat Society Market, Sector 78, Faridabad, Haryana-121002, India.</p>
								<p to=""><i className="fas fa-envelope px-2"></i>info@fever99.com</p>
								<p to=""><i className="fas fa-phone px-1"></i> +91 6262808062</p>
							</div>
						</div>
					</div>
					<hr />
					<div className="container mt-2" style={{ marginBottom: "-30px" }}>
						<div className="copyright" style={{ textAlign: "center" }}>
							&copy; Copyright{" "}
							<strong>
								<span>Fever99 Healthcare Solutions Pvt Ltd</span>
							</strong>
							. All Rights Reserved</div>
					</div>
				</div >
			</div >
			{/* Footer End  */}

		</>
	)
}

export default MainFooter